import axios from 'axios';
import { getReferenceDate } from 'helpers/DateFormatter';
import { APIEndpoints } from 'helpers/APILists';
import { MOACTIONS } from './MOSelection.constants';
import { sortFunction } from '../SubSections/DPS/DPS.helpers';
import { MESSAGE_TYPE } from '../../common/common.constants';
import { moSelectionInitialState } from './MOSelection.data';
import _ from 'lodash';

export function exampleAction(text) {
    return dispatch => {
        dispatch({
            type: 'AUTH_SUCCESS',
            payload: { success: true },
            meta: { message: text }
        });
    };
}

export const getAllMOData = () => async (dispatch, getState) => {
    const { Home: { selectedAssetName, selectedBarrierType, regionName }, AppData: { isMRATOnline } } = getState();
    if (isMRATOnline) {
        dispatch({
            type: MOACTIONS.GET_MORECORDS_PENDING,
            payload: {
                tableLoading: true,
                searchCriteria: { ...moSelectionInitialState.searchCriteria },
                moDataAll: [],
                testStatusFilterMo: 'All',
                filteredMoData: []
            }
        });
        const filterData = { Region: regionName, Asset: selectedAssetName, BarrierType: selectedBarrierType };
        await axios.post(APIEndpoints.GetVmSearchMo, filterData)
            .then((res) => {
                const moData = res.data;
                const totalCount = res.data.length;
                sortFunction(moData, 'ScheduleFinishDate', true).then(sortedData => dispatch({
                    type: MOACTIONS.GET_MORECORDS_SUCCESS,
                    payload: {
                        tableLoading: false,
                        moDataAll: sortedData,
                        searchCriteria: { ...moSelectionInitialState.searchCriteria },
                        testStatusFilterMo: 'All',
                        totalCount,
                        filteredMoData: sortedData
                    }
                }));
            })
            .catch(error => {
                dispatch({
                    type: MOACTIONS.GET_MORECORDS_FAILURE,
                    payload: {
                        tableLoading: false,
                    },
                    meta: { messageType: MESSAGE_TYPE.ERROR, message: error.message, exception: error }
                });
            });
    }
};

export const getAllMODataForSearch = () => async (dispatch, getState) => {
    const { Home: { selectedAssetName, selectedBarrierType, regionName }, AppData: { isMRATOnline } } = getState();
    if (isMRATOnline) {
        dispatch({
            type: MOACTIONS.GET_MORECORDS_PENDING,
            payload: {
                tableLoading: true,
                moDataAll: [],
                filteredMoData: []
            }
        });
        const filterData = { Region: regionName, Asset: selectedAssetName, BarrierType: selectedBarrierType };
        await axios.post(APIEndpoints.GetVmSearchMo, filterData)
            .then((res) => {
                const moData = res.data;
                const totalCount = res.data.length;
                sortFunction(moData, 'ScheduleFinishDate', true).then(sortedData => dispatch({
                    type: MOACTIONS.GET_MORECORDS_SUCCESS,
                    payload: {
                        tableLoading: false,
                        moDataAll: sortedData,
                        totalCount,
                        filteredMoData: sortedData
                    }
                }));
            })
            .catch(error => {
                dispatch({
                    type: MOACTIONS.GET_MORECORDS_FAILURE,
                    payload: {
                        tableLoading: false,
                    },
                    meta: { messageType: MESSAGE_TYPE.ERROR, message: error.message, exception: error }
                });
            });
    }
};

export const setDatePicker = (type, customStartDate, customEndDate) => (dispatch) => {
    let startDate;
    let endDate;
    const currentDate = new Date();
    if (type === 'Today') {
        startDate = currentDate;
        endDate = currentDate;
    } else if (type === 'Tomorrow') {
        startDate = getReferenceDate(currentDate, 1);
        endDate = getReferenceDate(currentDate, 1);
    } else if (type === 'All') {
        startDate = getReferenceDate(currentDate, -3000);
        endDate = getReferenceDate(currentDate, 3500);
    } else if (type === 'Custom') {
        startDate = customStartDate;
        endDate = customEndDate;
    }
    return dispatch(
        {
            type: MOACTIONS.SET_DATE_FOR_MO_SCREEN_SUCCESS,
            payload: {
                startDate,
                endDate
            }
        }
    );
};

export const reSetDateFilter = () => (dispatch) => {
    const dateObj = new Date();
    dispatch({
        type: MOACTIONS.RESET_DATE_FOR_MO_SCREEN_SUCCESS,
        payload: {
            startDate: new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate() - 30),
            endDate: new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate() + 35)
        }
    });
};

export const setDataForTagSelectionMOScreen = (existingState) => (dispatch) => {
    dispatch({
        type: MOACTIONS.SET_MORECORD_ROW,
        payload: {
            selectedRow: existingState
        }
    });
};

export const sortMO = (colForSorting, sortAscOrder) => (dispatch, getState) => {
    dispatch({
        type: MOACTIONS.GET_SORTMORECORDS_PENDING,
        payload: {
            tableLoading: true
        }
    });

    const { MOSelection: { moDataAll } } = getState();

    sortFunction(moDataAll, colForSorting, sortAscOrder)
        .then(sortedData => {
            dispatch({
                type: MOACTIONS.GET_SORTMORECORDS_SUCCESS,
                payload: {
                    tableLoading: false,
                    moDataAll: sortedData
                }
            });
        }
        )
        .catch(error => {
            dispatch({
                type: MOACTIONS.GET_SORTMORECORDS_FAILURE,
                payload: {
                    tableLoading: false,
                },
                meta: { messageType: MESSAGE_TYPE.ERROR, message: error.message, exception: error }
            });
        }
        );
};

function buildTagsByMoNumber(tags, tagsBi, selectedRowTags = []) {
    const tagsByMoNumber = {};
    const selectedRowGropued = _.groupBy(selectedRowTags, 'HdWorkOrder');
    const tagsGrouped = _.groupBy(tags, 'HdWorkOrder');
    const tagsBiGrouped = _.groupBy(tagsBi, 'HdWorkOrder');
    const temp = { ...tagsGrouped, ...selectedRowGropued };
    const temp2 = { ...tagsBiGrouped, ...selectedRowGropued };

    Object.keys(temp).forEach(key => {
        tagsByMoNumber[key] = temp[key];
    });
    Object.keys(temp2).forEach(key => {
        if (!tagsByMoNumber[key] || tagsByMoNumber[key].length === 0) {
            tagsByMoNumber[key] = temp2[key];
        }
    });
    return tagsByMoNumber;
}

function searchMODescriptionFunction(searchObj = moSelectionInitialState.searchCriteria, searchSpace = [], testStatusFilterMo = 'All', tags = [], tagsBi = [], selectedRowTags = []) {
    const tagsByMoNumber = buildTagsByMoNumber(tags, tagsBi, selectedRowTags);
    return searchSpace.filter(row => {
        const matchesSearch = row.HdWorkOrderDescription?.toLowerCase().includes(searchObj.moDescription.toLowerCase())
            && row.HdWorkOrder?.toLowerCase().includes(searchObj.moNumber.toLowerCase())
            && row.HdLocation?.toLowerCase().includes(searchObj.functionalLocation.toLowerCase());
        const moTags = tagsByMoNumber[row.HdWorkOrder] || [];
        if (moTags.length === 0) return false;
        const isTested = moTags.length > 0 && moTags.every(item => !!item.DateTested);
        const isNotTested = moTags.length > 0 && moTags.some(item => !item.DateTested);
        const matchesTestStatus = (testStatusFilterMo === 'All'
            || (testStatusFilterMo === 'Tested' && isTested)
            || (testStatusFilterMo === 'Not Tested' && isNotTested));
        return matchesSearch && matchesTestStatus;
    });
}

export const searchMODescription = (searchVal, name) => (dispatch, getState) => {
    const { MOSelection: { moDataAll, searchCriteria, testStatusFilterMo }, Home: { tags, tagsBi, tagsLoaded, tagsBiLoaded }, AppData: { isMRATOnline }, TagSelectionMOScreen: { selectedRowTags } } = getState();
    if (isMRATOnline) {
        dispatch(getAllMODataForSearch());
    }
    const filterData = {
        ...searchCriteria,
        [name]: searchVal
    };
    dispatch({
        type: MOACTIONS.GET_SEARCHMORECORDS_PENDING,
        payload: {
            tableLoading: true,
            searchCriteria: { ...filterData }
        }
    });
    let filteredMoData = [];
    if (tagsLoaded && tagsBiLoaded && moDataAll && moDataAll.length > 0) {
        filteredMoData = searchMODescriptionFunction(filterData, moDataAll, testStatusFilterMo, tags, tagsBi, selectedRowTags);
    }
    dispatch({
        type: MOACTIONS.GET_SEARCHMORECORDS_SUCCESS,
        payload: {
            tableLoading: false,
            filteredMoData,
            totalCount: filteredMoData.length
        }
    });
};

const filterMoData = (moDataAll, searchCriteria, testStatusFilterMo, tags, tagsBi, selectedRowTags) => {
    const tagsByMoNumber = buildTagsByMoNumber(tags, tagsBi, selectedRowTags);
    return moDataAll.filter(mo => {
        const moTags = tagsByMoNumber[mo.HdWorkOrder] || [];
        if (moTags.length === 0) return false;
        const isTested = moTags.length > 0 && moTags.every(item => !!item.DateTested);
        const isNotTested = moTags.length > 0 && moTags.some(item => !item.DateTested);
        const matchesTestStatus = (testStatusFilterMo === 'All'
            || (testStatusFilterMo === 'Tested' && isTested)
            || (testStatusFilterMo === 'Not Tested' && isNotTested));
        const matchesSearchCriteria = mo.HdWorkOrderDescription?.toLowerCase().includes(searchCriteria.moDescription.toLowerCase())
            && mo.HdWorkOrder?.toLowerCase().includes(searchCriteria.moNumber.toLowerCase())
            && mo.HdLocation?.toLowerCase().includes(searchCriteria.functionalLocation.toLowerCase());
        return matchesTestStatus && matchesSearchCriteria;
    });
};

export const setAndFilterMoData = (filter) => (dispatch, getState) => {
    const { MOSelection: { moDataAll, searchCriteria, testStatusFilterMo }, Home: { tags, tagsBi, tagsLoaded, tagsBiLoaded }, TagSelectionMOScreen: { selectedRowTags } } = getState();
    dispatch({
        type: MOACTIONS.SET_AND_FILTER_TESTSTATUS_FILTERS_MO,
        payload: {
            testStatusFilterMo: filter ?? testStatusFilterMo
        }
    });
    if (tagsLoaded && tagsBiLoaded && moDataAll && moDataAll.length > 0) {
        const filteredMoData = filterMoData(moDataAll, searchCriteria, filter ?? testStatusFilterMo, tags, tagsBi, selectedRowTags);
        dispatch({
            type: MOACTIONS.SET_AND_FILTER_TESTSTATUS_FILTERS_MO,
            payload: {
                totalCount: filteredMoData.length,
                filteredMoData,
                testStatusFilterMo: filter ?? testStatusFilterMo,
            }
        });
    }
};
